import { render, staticRenderFns } from "./btnCallCode.vue?vue&type=template&id=044bab0c&scoped=true"
import script from "./btnCallCode.vue?vue&type=script&lang=js"
export * from "./btnCallCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044bab0c",
  null
  
)

export default component.exports